import { camelCase, mapKeys } from 'lodash/fp';
import { ICustomer } from '@whitelabel/helpers/types';
import { xcoverAPI } from '..';

export const customerAPI = xcoverAPI.injectEndpoints({
  endpoints: (builder) => ({
    checkCustomer: builder.mutation<ICustomer, { media: string }>({
      query: (body) => ({ url: 'customers/lookup/?language=en', method: 'POST', body }),
    }),
    getCustomerByID: builder.query<ICustomer, { id: string; locale: string }>({
      query: ({ id, locale }) => ({
        url: `customers/${id}/?language=${locale}`,
      }),
      transformResponse: (response: ICustomer) => <ICustomer>(<unknown>mapKeys(camelCase)(response)),
    }),
  }),
  overrideExisting: false,
});
